import { ServerConfigService } from 'src/app/share/service/server-config.service';
import { Directive, Input, SimpleChanges, ElementRef, AfterViewInit, OnChanges, Output, EventEmitter, NgZone } from '@angular/core';

@Directive({
  selector: '[appEncodeBackgroundImageUrl]',
  exportAs: 'encodeBackgroundImageUrl',
})
export class EncodeBackgroundImageUrlDirective implements AfterViewInit, OnChanges {
  @Input('appEncodeBackgroundImageUrl') src: string;
  @Input() backgroundImageErrorDefaultUrl = '/assets/images/no-pic.webp';
  encodedUrl: string;
  el: HTMLElement;

  constructor(
    private elRef: ElementRef,
    private zone: NgZone,
    private serverConfigService: ServerConfigService,
  ) { }

  ngAfterViewInit(): void {
    if (this.elRef) {
      this.el = this.elRef.nativeElement;
      this.setPresentSrcUrl();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.src && this.serverConfigService.isBrowser) {
      const image = new Image();
      image.onerror = (e) => {
        this.zone.run(() => {
          image.src = this.backgroundImageErrorDefaultUrl;
          // this.encodedUrl = encodeURI(this.backgroundImageErrorDefaultUrl);
          // this.setPresentSrcUrl(this.encodedUrl);
        });
      };
      image.onload = (e) => {
        this.zone.run(() => {
          this.encodedUrl =(e.target as HTMLImageElement).src;
          this.setPresentSrcUrl();
        });
      };
      image.src = this.isNotEncodeDomain(this.src) ? this.src : encodeURI(this.src);
    } else if (this.serverConfigService.isServer) {
      this.encodedUrl = this.isNotEncodeDomain(this.src) ? this.src : encodeURI(this.src);
      this.setPresentSrcUrl();
    }
  }

  private setPresentSrcUrl() {
    if (this.el && this.encodedUrl) {
      this.el.style.backgroundImage = `url('${this.encodedUrl}')`;
    }
  }

  /** 2024/7/8 Loki:
   * 因為現在確定會在本系統是GCS的檔案連結可能會有這兩個
   * 一個是 原本的GCS連結  另一個是 中華配的GCS的連結
   * 因為他copy到新的bucket上面的檔案全部的ACL都是不公開的
   * 所以我只好還是產生驗證參數放到這的網域上面
   *
   * 所以只有圖片檔案網域是這兩個, 不需要將圖片特別encode
   */
  private isNotEncodeDomain(src: string): boolean {
    const imageUrl = new URL(src);
    return imageUrl.host === 'storage.googleapis.com'
        || imageUrl.host === 'tcmbfile.culture.tw'
    ;
  }
}
